<template>
  <div>
    <Control :card="false" :icon="'mdi mdi-format-list-numbered'" :title="'Регламентированная отчетность, форма ' + fnoname" :links="links" :premium="true">
      <div class="form-inline float-right">
        <b-form-checkbox class="mr-sm-1" :value="1" :unchecked-value="0" v-model="params.paid">Заполнять графу "Выплачено доходов" суммами "К выплате"</b-form-checkbox>
        <SelectOrg :name="'orgs'" :table="'reg_organizations'"
                   :fields="['name']" class="mr-sm-1"></SelectOrg>
        <template v-if="fnoperiod == 'halfyear'">
          <Enums class=" mr-sm-1" :type="'enum'" :name="'halfyears'" v-model="period.halfyear"></Enums>
        </template>
        <template v-if="fnoperiod == 'quarter'">
          <Enums class=" mr-sm-1" :type="'enum'" :name="'quarters'" v-model="period.quarter"></Enums>
        </template>
        <Enums class="mr-sm-1" :type="'enum'" :name="'years'" v-model="period.year"></Enums>
        <b-button class="mr-sm-1" size="sm" variant="primary" @click="Report()">Сформировать отчет
        </b-button>
        <a @click="this.clearLink" class="btn btn-sm btn-success ml-sm-2" target="_blank" v-b-tooltip:hover title="Правой кнопкой мыши по данной кнопке и в появившемся меню нажмите СОХРАНИТЬ ССЫЛКУ КАК" download v-if="typeof result.link !== 'undefined' && result.link !== ''"
           :href="result.link">Скачать XML файл</a>
      </div>
    </Control>

    <div class="container-fluid" v-if="user.registered && !user.subscribe_expired">



      <div class="">
        <!--<h5 class="text-center">{{fnotitle}}</h5>
        <hr>-->



        <template v-if="typeof result.info !== 'undefined'">
          <b-card no-body>
           <b-tabs v-if="typeof result.data !== 'undefined'" pills card vertical nav-wrapper-class="w-nav" content-class="w-content">
             <b-tab v-for="(itemSheet, indexSheet) in result.data" :key="indexSheet">
               <template v-slot:title>
                 <div style="font-size: 0.8rem">{{ itemSheet.name }}</div>
               </template>
               <b-card-text>
                 <div v-if="result.alert" class="alert alert-danger" v-html="result.alert"></div>
                 <h5 class="text-center" v-if="typeof itemSheet.name !== 'undefined'">{{ itemSheet.name }}</h5>
                 <!-- Тип Страница -->
                 <template v-if="itemSheet.type == 'sheet'">
                   <b-tabs content-class="mt-3">
                     <b-tab v-for="(itemPage, indexPage, numberPage) in itemSheet.pages" :key="indexPage" :title="'Страница ' + (numberPage + 1)">

                       <div class="row">
                         <template v-for="(itemField, indexField) in itemPage">
                           <div v-if="typeof itemField.section !== 'undefined'" class="col-12 mb-1" :key="indexField">
                             <div class="p-1 bg-dark text-white text-center">{{ itemField.section }}</div>
                           </div>
                           <div v-if="typeof itemField.maintitle !== 'undefined'" class="col-12 mb-1" :key="indexField">
                             <div class="py-1">
                               <span class="bg-primary text-white px-1 d-inline-block" v-if="typeof itemField.code !== 'undefined'">{{ itemField.code }}</span> {{ itemField.maintitle }}
                             </div>
                           </div>
                           <div :class="typeof itemField.col !== 'undefined' ? ['col-md-' + itemField.col, 'mb-1'] : ['col-12', 'mb-1']" :key="indexField">
                             <div class="row">
                               <div v-if="itemField.title != ''" :class="typeof itemField.col !== 'undefined' ? ['col-7', 'text-right'] : ['col-7']">
                                 <div class="border-bottom py-1">
                                   <template v-if="typeof itemField.col === 'undefined'">
                                     <span v-if="typeof itemField.code !== 'undefined' && typeof itemField.maintitle === 'undefined'" class="bg-primary text-white px-1 d-inline-block">{{ itemField.code }}</span><span class="d-inline-block pl-1">{{ itemField.title }}</span>
                                   </template>
                                   <template v-else>
                                     <small>{{ itemField.title }}</small>
                                   </template>
                                 </div>
                               </div>
                               <div :class="itemField.title != '' ? 'col-5' : 'col-12'">
                                 <template v-if="result.data[indexSheet][indexPage][indexField] == 'true'">
                                   <b-form-checkbox disabled value="1" unchecked-value="0" checked="1" />
                                 </template>
                                 <template v-else-if="result.data[indexSheet][indexPage][indexField] == 'false'">
                                   <b-form-checkbox disabled value="1" unchecked-value="0" checked="0" />
                                 </template>
                                 <template v-else>
                                   <div :class="typeof itemField.color !== 'undefined' && itemField.color != '' ? ['bg-' + itemField.color + '-light', 'border', 'p-1'] : ['bg-light', 'border', 'p-1']">
                                     {{ result.data[indexSheet][indexPage][indexField] }}
                                   </div>
                                 </template>
                               </div>
                             </div>
                           </div>
                         </template>
                       </div>

                     </b-tab>
                   </b-tabs>
                 </template>

                 <template v-if="itemSheet.type == 'table'">

                   <b-tabs content-class="mt-3">
                     <b-tab v-for="(itemPage, indexPage, numberPage) in itemSheet.pages" :key="indexPage" :title="'Страница ' + (numberPage + 1)">
                       <table class="table table-sm table-bordered">
                         <thead>
                         <tr>
                           <th v-for="(itemField, indexField) in itemPage" :key="indexField" >{{ itemField.title }}</th>
                         </tr>

                         <!-- Суммы-->
                         <tr>
                           <td class="bg-light" v-for="(itemField, indexField) in itemPage" :key="indexField" >
                             <template v-if="typeof itemSheet[indexField + '_SUM'] !== 'undefined'">{{ itemSheet[indexField + '_SUM'] }}</template>
                           </td>
                         </tr>

                         <tr v-for="(itemData, indexData) in itemSheet.rows" :key="indexData">
                           <td v-for="(itemField, indexField) in itemPage" :key="indexField">{{ itemData[indexField] }}</td>
                         </tr>
                         </thead>
                       </table>
                     </b-tab>
                   </b-tabs>
                 </template>
               </b-card-text>
             </b-tab>
           </b-tabs>
          </b-card>
        </template>

        <h4>Как сформировать XML файл отчета?</h4>
        <ul class="list-group list-group-flush mb-5">
          <li class="list-group-item">1. Выберите период и нажмитке кнопку "Сформировать отчет" на панели сверху справа.</li>
          <template v-if="typeof result.info !== 'undefined'">
            <li class="list-group-item">2. Сформирована форма {{fnoname}} версии {{result.info.version}}. Теперь вы можете скачать XML файл отчёта для импорта в СОНО или Кабинет налогоплательщика. Кнопка для скачивания XML на панели сверху справа. Если при нажатии на кнопку скачивания XML форма открывается в браузере, то скачайте, нажав правой кнопкой мыши на кнопку скачивания и выбрав в меню "Сохранить ссылку как".</li>
            <li class="list-group-item">3. Обратите внимание, что заполняются только поля, которые касаются заработной платы. Остальные данные вы должны заполнить самостоятельно после импорта данной формы в СОНО или Кабинет налогоплательщика.</li>
            <li class="list-group-item">4. Если вы заметили какие-либо ошибки или неточности при заполнении данного отчета, то напишите разработчику в Whatsapp по телефону +7 701 842-25-01.</li>
          </template>

        </ul>
        <h4>Как импортировать XML файл в Кабинет налогоплательщика или СОНО?</h4>
        <p>В Кабинете налогоплательщика переходите по меню "Формы налоговой отчетности" -> "Импорт форм", нажмите на кнопку "Выберите файл" и укажите путь к скачанному с калькулятора XML файлу. После этого нажмите кнопку "Импорт" и отчет должен открыться в Кабинете налогоплательщика.</p>
        <p>В приложении СОНО в разделе "Мои формы" нажмите кнопку "Импортировать файл" ии укажите путь к скачанному с калькулятора XML файлу. Отчет доллжен открыться в приложении СОНО. </p>
      </div>

    </div>

    <Premium v-else />
  </div>
</template>

<script>
import SelectOrg from "@/components/base/SelectOrg";
import Enums from "@/components/base/Enums";
import Control from "@/components/base/ControlPanel";
import Premium from "@/components/base/Premium"
import {mapGetters} from "vuex";


export default {
  name: 'Form',
  components: {
    SelectOrg, Enums, Control, Premium
  },
  props: ['fnoname', 'fnoperiod', 'fnotitle'],
  data: function () {
    return {
      links: [
        {name: 'Калькулятор заработной платы', link: '/', icon: 'mdi mdi-calculator'},
      ],
      params: {
        paid: 1
      },
      period: {
        year: new Date().getFullYear(),
        halfyear: 0,
        quarter: 0
      },
      result: {},
    }
  },
  methods: {
    Report: function () {
      this.result = {} // Обнуляем результат перед запросом
      this.$store.commit('wait', {state: true, name: 'Формирование отчета ' + this.fnoname});
      this.$http
          .post(this.$apiold, {
            task: 'report',
            org: this.org,
            fno: {name: this.fnoname, period: this.fnoperiod},
            period: this.period,
            params: this.params
          })
      .then(response => {
        this.$store.commit('wait', {state: false});
        this.$store.commit('user', response.data.user);

        // Сообщения
        this.$store.commit('alert', response.data.messages);

        if (!response.data.error) {

          this.result = response.data.result;

        }
      })
    },
    clearLink: function () {

    }
  },
  computed: {
    ...mapGetters({
      org: 'org',
      user: "user"
    })
  }
}
</script>

<style>
.w-nav {
  width: 20%;
}
.w-content {
  width: 80%;
}
</style>
